// src/components/common/TigerLogo.js
import React from "react";

export default function TigerLogo({ size = 48, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Ears */}
      <polygon points="18,8 8,32 30,28" fill="#f97316" />
      <polygon points="82,8 92,32 70,28" fill="#f97316" />
      <polygon points="20,12 14,30 28,27" fill="#292929" />
      <polygon points="80,12 86,30 72,27" fill="#292929" />

      {/* Head shape */}
      <ellipse cx="50" cy="52" rx="38" ry="40" fill="#f97316" />

      {/* Tiger stripes on forehead */}
      <path d="M35 25 Q38 35 34 42" stroke="#292929" strokeWidth="3" strokeLinecap="round" fill="none" />
      <path d="M50 20 Q50 32 50 40" stroke="#292929" strokeWidth="3" strokeLinecap="round" fill="none" />
      <path d="M65 25 Q62 35 66 42" stroke="#292929" strokeWidth="3" strokeLinecap="round" fill="none" />

      {/* White face patches */}
      <ellipse cx="50" cy="62" rx="24" ry="22" fill="#fff7ed" />

      {/* Eyes */}
      <ellipse cx="37" cy="48" rx="8" ry="7" fill="white" />
      <ellipse cx="63" cy="48" rx="8" ry="7" fill="white" />
      <ellipse cx="38" cy="48" rx="4.5" ry="5" fill="#292929" />
      <ellipse cx="64" cy="48" rx="4.5" ry="5" fill="#292929" />
      {/* Eye glints */}
      <circle cx="40" cy="46" r="1.5" fill="white" />
      <circle cx="66" cy="46" r="1.5" fill="white" />

      {/* Nose */}
      <path d="M45 60 Q50 55 55 60 Q50 64 45 60Z" fill="#292929" />

      {/* Mouth */}
      <path d="M50 64 Q50 68 45 72" stroke="#292929" strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M50 64 Q50 68 55 72" stroke="#292929" strokeWidth="2" strokeLinecap="round" fill="none" />

      {/* Whisker dots */}
      <circle cx="42" cy="66" r="1" fill="#9a3412" />
      <circle cx="40" cy="68" r="1" fill="#9a3412" />
      <circle cx="38" cy="66" r="1" fill="#9a3412" />
      <circle cx="58" cy="66" r="1" fill="#9a3412" />
      <circle cx="60" cy="68" r="1" fill="#9a3412" />
      <circle cx="62" cy="66" r="1" fill="#9a3412" />

      {/* Chin / jaw stripes */}
      <path d="M30 55 Q25 60 22 70" stroke="#292929" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      <path d="M70 55 Q75 60 78 70" stroke="#292929" strokeWidth="2.5" strokeLinecap="round" fill="none" />
    </svg>
  );
}
